module.exports = __webpack_public_path__ + "static/media/tablefabric-red.8022bf10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tablefabric-red.jpg
// module id = 668
// module chunks = 0